export default __webpack_public_path__ + "static/media/passive-fund-info.54ad589e.jpg";